import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import image from "../assets/siam.jpeg"
import RatingStars from "../components/common/RatingStars";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import CourseDetailsCardSIAM from "../components/core/Course/CourseDetailsCardSIAM";
import ReactMarkdown from "react-markdown";
import { BsFillCaretRightFill, BsFillCaretRightSquareFill } from "react-icons/bs";
import CourseAccordionBar from "../components/core/Course/CourseAccordionBar"
import Footer from "../components/common/Footer";

const CourseDetails = () => {
  const [isActive, setIsActive] = useState(Array(0));
  const handleActive = () => {
    // console.log("called", id)
    setIsActive(

    );
  };

  return (
    <>
      <div className={`relative w-full bg-richblue-5`}>
        <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
          <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
            <div className="relative block max-h-[30rem] lg:hidden">
              <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
              <img
                src={image}
                alt="course thumbnail"
                className="aspect-auto w-full"
              />
            </div>

            <div
              className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblue-700`}
            >
              <div>
                <p className="text-4xl font-bold text-richblue-700 sm:text-[42px]">
                SIAM Foundation - Training and Certification
                </p>
              </div>

              <p className={`text-richblue-500`}>
              With the increasing complexity of multi-sourced IT environments and the need for seamless service integration, SIAM® (Service Integration and Management) has emerged as a globally recognized framework for managing and integrating services across multiple providers.
              By mastering SIAM® concepts, participants will gain the skills to optimize service delivery, enhance collaboration among providers, and ensure alignment with business objectives. 
              </p>
              <div className="text-md flex flex-wrap items-center gap-2">
                <span className="text-yellow-25">5</span>
                <RatingStars Review_Count={5} Star_Size={20} />
                <span>{`(${5} reviews)`}</span>
                <span> | </span>
                <span>{`${200}+ Professionals Enrolled`}</span>
              </div>

              <div className="flex flex-wrap gap-5 text-lg">
                <p className="flex items-center gap-2">
                  {" "}
                  <BiInfoCircle /> Created at February 15, 2024 | 8:01 PM
                </p>
                <p className="flex items-center gap-2">
                  {" "}
                  <HiOutlineGlobeAlt /> English
                </p>
              </div>
            </div>
            <div className="flex w-full flex-col gap-4 border-y border-y-richblue-300 py-4 lg:hidden">
              <p className="space-x-3 pb-4 text-3xl font-semibold text-richblue-700">
                Rs. {19999}
              </p>
              <button className="yellowButton">Enroll Now</button>
              <button className="blackButton">Request Free Demo</button>
            </div>
          </div>
          {/* Courses Card */}
          <div className="right-[2rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
            <CourseDetailsCardSIAM />
          </div>
        </div>
      </div>
      <div className="mx-auto box-content px-4 text-start text-richblue-700 lg:w-[1260px]">
        <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
          {/* What will you learn section */}
          <div className="my-8 border border-richblue-300 p-8">
            <p className="text-3xl font-semibold">Course Overview</p>
            <div className="mt-5">
              <ReactMarkdown>
                {
                   "Today's complex IT landscape often involves a mix of internal teams and external providers, requiring seamless integration for effective service delivery.  Service Integration and Management (SIAM®) provides the framework for navigating this multi-vendor environment, ensuring alignment, collaboration, and optimized performance."
                }
              </ReactMarkdown>
              <ReactMarkdown>
                {
                  "This comprehensive course delves into the core principles and practices of SIAM, equipping participants with the knowledge to establish robust governance, foster collaboration, and drive continuous improvement across multiple service providers.  From understanding the SIAM lifecycle to managing intricate relationships and mitigating risks, this training prepares you to effectively orchestrate complex IT services and deliver exceptional business value."
                }
              </ReactMarkdown>
            </div>
            <p className="text-3xl font-semibold mt-5">What you'll learn</p>
            <div className="flex flex-col gap-3 mt-5">
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Understand the core principles and concepts of SIAM and its importance in modern IT service management.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Utilize the SIAM lifecycle to plan, implement, operate, and improve integrated service delivery.</span>
                </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Enhance operational efficiency through effective service management practices.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Develop strategies for successful collaboration within a multi-vendor environment.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Identify and mitigate risks associated with service integration and management.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Gain practical insights into the challenges and best practices of SIAM adoption.

                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                   Prepare for and successfully complete the SIAM Foundation certification exam.
                </span>
              </p>
            </div>
          </div>

          {/* Course Content Section */}
          <div className="max-w-[830px] ">
            <div className="flex flex-col gap-3">
              <p className="text-[28px] font-semibold">Course Curriculum</p>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="flex gap-2">
                  <span>
                    {8} {`module(s)`} &nbsp; |
                  </span>
                  <span>
                    {27} {`lecture(s)`} &nbsp; |
                  </span>
                  <span>{"1h 10m"} total length</span>
                </div>
                <div>
                  <button
                    className="text-yellow-25"
                    onClick={() => setIsActive([])}
                  >
                    Collapse all sections
                  </button>
                </div>
              </div>
            </div>

            {/* Course Details Accordion */}
            <div className="py-4 ">
              <CourseAccordionBar
                courseName = {"Module 1: SIAM Implementation Roadmap"}
                courseList = {[
                    "Describe the different phases of the SIAM implementation roadmap.",
                    "Explain the activities and deliverables within each phase.",
                    "Understand the importance of planning and preparation in SIAM implementation.",
                    "Identify the key stakeholders involved in the SIAM implementation process."
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 2: SIAM Roles and Responsibilities"}
                courseList={[
                "Identify and describe the key roles within a SIAM ecosystem.",
    "Understand the responsibilities associated with each role.",
    "Explain the RACI matrix and its application in SIAM.",
    "Discuss the importance of role clarity and accountability in SIAM."]}                
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 3: SIAM Practices"}
                courseList={[
                "Understand the key practices that support SIAM.",
    "Describe the purpose and benefits of each practice.",
    "Explain how these practices contribute to effective service integration and management.",
    "Learn how to implement and improve these practices within a SIAM environment."
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />{" "}
              <CourseAccordionBar
                courseName={"Module 4: Processes to Support SIAM"}
                courseList={[
                "Identify the key processes that support SIAM.",
    "Describe the purpose and benefits of each process.",
    "Explain how these processes contribute to effective service integration and management.",
    "Learn how to implement and improve these processes within a SIAM environment."
               ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 5: SIAM Challenges and Risks"}
                courseList={[
                "Identify the common challenges and risks associated with SIAM implementation.",
    "Understand the potential impact of these challenges and risks.",
    "Learn how to mitigate these challenges and risks.",
    "Develop strategies for successful SIAM implementation."

                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
            </div>


          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CourseDetails;
